import { a as GITHUB_API_KEY } from "./private.js";
import { Octokit } from "@octokit/rest";
const octokit = new Octokit({
  auth: GITHUB_API_KEY
});
export {
  octokit as o
};
